export const sharedBillingWorkspaceDe = {
  "Billing": "Abrechnung",
  "Billing and credits": "Abrechnung & Guthaben",
  "Overview and plan": "Überblick & Tarif",
  "Invoices": "Rechnungen",
  "Invoice details": "Rechnungsdaten",
  "Invoice number": "Rechnungsnummer",
  "Invoice date": "Rechnungsdatum",
  "Service period": "Leistungszeitraum",
  "Amount": "Betrag",
  "Status": "Status",
  "Document type": "Dokumenttyp",
  "Download": "Herunterladen",
  "No invoices": "Keine Rechnungen vorhanden",
  "Special services": "Sonderleistungen",
} as const;

export const sharedBillingWorkspaceEn = {
  "Billing": "Billing",
  "Billing and credits": "Billing & credits",
  "Overview and plan": "Overview & plan",
  "Invoices": "Invoices",
  "Invoice details": "Invoice details",
  "Invoice number": "Invoice number",
  "Invoice date": "Invoice date",
  "Service period": "Service period",
  "Amount": "Amount",
  "Status": "Status",
  "Document type": "Document type",
  "Download": "Download",
  "No invoices": "No invoices available",
  "Special services": "Special services",
} as const;

export const sharedBillingWorkspaceRu = {
  "Billing": "Оплата",
  "Billing and credits": "Оплата и кредиты",
  "Overview and plan": "Обзор и тариф",
  "Invoices": "Счета",
  "Invoice details": "Платёжные данные",
  "Invoice number": "Номер счёта",
  "Invoice date": "Дата счёта",
  "Service period": "Период оказания услуг",
  "Amount": "Сумма",
  "Status": "Статус",
  "Document type": "Тип документа",
  "Download": "Скачать",
  "No invoices": "Счета отсутствуют",
  "Special services": "Дополнительные услуги",
} as const;

export const sharedBillingWorkspaceUk = {
  "Billing": "Оплата",
  "Billing and credits": "Оплата та кредити",
  "Overview and plan": "Огляд і тариф",
  "Invoices": "Рахунки",
  "Invoice details": "Платіжні дані",
  "Invoice number": "Номер рахунку",
  "Invoice date": "Дата рахунку",
  "Service period": "Період надання послуг",
  "Amount": "Сума",
  "Status": "Статус",
  "Document type": "Тип документа",
  "Download": "Завантажити",
  "No invoices": "Рахунків немає",
  "Special services": "Додаткові послуги",
} as const;

export const sharedBillingWorkspaceIt = {
  "Billing": "Fatturazione",
  "Billing and credits": "Fatturazione e crediti",
  "Overview and plan": "Panoramica e piano",
  "Invoices": "Fatture",
  "Invoice details": "Dati di fatturazione",
  "Invoice number": "Numero fattura",
  "Invoice date": "Data fattura",
  "Service period": "Periodo di servizio",
  "Amount": "Importo",
  "Status": "Stato",
  "Document type": "Tipo di documento",
  "Download": "Scarica",
  "No invoices": "Nessuna fattura disponibile",
  "Special services": "Servizi aggiuntivi",
} as const;
